import { Modal, Toast } from '@seiue/ui'
import React, { useEffect, useState } from 'react'
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from 'react-beautiful-dnd'
import styled from 'styled-components'

import { GrowpIcon } from 'packages/components/GrowpIcon'
import { Outline, SortBlock, courseApi } from 'packages/sdks-next/growp'
import { dragReorder } from 'packages/utils'

/**
 * 分组排序弹窗
 *
 * @param props - props
 * @param props.hide - 关闭弹窗
 * @param props.outlines - 大纲数据
 * @returns modal
 */
export const SortGroupModalContent: React.FC<{
  hide: () => void
  outlines: Outline[]
}> = ({ outlines, hide }) => {
  const [dragItems, setDragItems] = useState<
    { name?: string; id: number; weight?: number }[]
  >([])

  const { api: batchSortOutlines } = courseApi.useBatchSortOutlines({
    reload: [courseApi.loadCourseActivityTask],
  })

  useEffect(() => {
    const editableGroups = outlines
      .sort((a, b) => (a.weight || 0) - (b.weight || 0))
      .map((g, idx) => ({
        id: g.id,
        name: g.name,
        weight: g.weight ? g.weight : idx,
      }))

    setDragItems(editableGroups)
  }, [outlines])

  const onDragEnd = async (result: DropResult) => {
    if (!result.destination) {
      return
    }

    const newItems = dragReorder(
      dragItems,
      result.source.index,
      result.destination.index
    )

    setDragItems(newItems)
  }

  return (
    <>
      <Wrapper>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {dragItems.map((item, index) => (
                  <Draggable
                    key={item.id}
                    draggableId={String(item.id)}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <Item
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={provided.draggableProps.style}
                        $isDragging={snapshot.isDragging}
                      >
                        <ItemName>{item.name}</ItemName>
                        <GrowpIcon
                          name="DragVertical"
                          size={16}
                          style={{
                            cursor: snapshot.isDragging ? 'grabbing' : 'grab',
                          }}
                        />
                      </Item>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Wrapper>
      <Modal.Footer
        okText={'确定'}
        onOk={async () => {
          const sortReq: SortBlock[] = dragItems.map((item, index) => ({
            id: item.id,
            weight: index,
          }))

          await batchSortOutlines(sortReq)
          Toast.success('排序成功')
          hide()
        }}
        okButtonProps={{
          style: {
            backgroundColor: 'red !important',
          },
        }}
        onCancel={() => {
          hide()
        }}
      />
    </>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 12px;
  overflow: auto;
  max-height: 300px;
`

const Item = styled.div<{
  $isDragging?: boolean
}>`
  &:hover {
    background-color: ${(props) => props.theme.background._3};
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 8px;
  width: 100%;
  border-radius: 8px;
  background-color: ${(props) =>
    props.$isDragging ? props.theme.brand._5 : '#fff'};
`

const ItemName = styled.div``
